import type { FC } from 'react';

interface ServiceCardProps {
  title: string;
  subtitle: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
}

const ServiceCard: FC<ServiceCardProps> = ({ title, subtitle, description, imageSrc, imageAlt }) => {
  return (
    <div className="flex flex-col h-full bg-white overflow-hidden">
      <div className="relative h-48">
        <img
          src={imageSrc}
          alt={imageAlt}
          className="w-full h-full object-cover"
        />
      </div>
      <div className="p-6 flex flex-col flex-grow">
        <h3 className="text-base font-raleway font-bold text-[#333333] mb-2">{title}</h3>
        <h4 className="text-base font-raleway font-light text-[#333333] mb-3">{subtitle}</h4>
        <p className="text-[14px] font-lato font-normal text-[#555555] flex-grow">{description}</p>
      </div>
    </div>
  );
};

export default ServiceCard;